import { useCallback, useEffect } from 'react'

import { usePathname, useRouter } from 'next/navigation'

interface UseRouteHashProps {
    hash: string
    onHashRemoved?: () => void
}

export function useRouteHash({ hash, onHashRemoved }: UseRouteHashProps) {
    const router = useRouter()
    const pathname = usePathname()

    const addHash = useCallback(() => {
        router.push(`#${hash}`, { scroll: false })
    }, [hash, router])

    const removeHash = useCallback(() => {
        router.replace(pathname, { scroll: false })
    }, [pathname, router])

    useEffect(() => {
        if (!onHashRemoved || typeof window === 'undefined') return

        const handleHashChange = () => {
            if (!window.location.hash.includes(hash)) {
                onHashRemoved()
            }
        }

        window.addEventListener('hashchange', handleHashChange)

        return () => window.removeEventListener('hashchange', handleHashChange)
    }, [hash, onHashRemoved])

    return { addHash, removeHash }
}
